import { Component, OnInit, Input } from '@angular/core';
import { IChatbotactivity } from 'src/app/Services/chatbot-service/chatbot.interface';
import { ChatbotService } from 'src/app/Services/chatbot-service/chatbot.service';

@Component({
	selector: 'app-bot-message',
	templateUrl: './bot-message.component.html',
	styleUrls: ['./bot-message.component.scss'],
})
export class BotMessageComponent implements OnInit {
	@Input() activity: IChatbotactivity;
	userMessage: boolean;

	constructor(private chatbotService: ChatbotService) {}

	ngOnInit(): void {
		this.userMessage = this.activity && this.activity.from && !this.activity.from.id.includes('hqxbot');
		if (this.activity && (this.activity.type === 'typing' || this.activity.type === 'error')) {
			this.userMessage = false;
		}
	}

	actionClick(action: string) {
		this.chatbotService.addConvActivity(action);
		setTimeout(() => {
			this.chatbotService.addconvTyping();
		}, 101);
	}
}
